// ─────────────────────────────────────────────────────────────────────────────
// BoneFlow's internal company + the platformAdmin permission (roadmap 5.10)
//
// The frontend half of functions/internalCompany.js + functions/platformAdmin.js
// — KEEP THE ID IN SYNC with those files and with firestore.rules, which
// compares against the same literal string.
//
// platformAdmin is NOT a company role and NOT one of the PERMISSION_KEYS in
// userService.js. Those all answer "what can this person do inside THEIR
// company"; platformAdmin answers "who runs the platform" — cross-company
// visibility plus access to BoneFlow's own internal company. It is a bare
// boolean on the user document:
//
//   users/{uid}.platformAdmin === true
//
// SET MANUALLY, NEVER SELF-ASSIGNABLE. Nothing in the app writes this field.
// firestore.rules rejects any client write that touches it — including a user
// updating their own document and an owner updating a teammate's — so the only
// way to grant it is server-side (the Firestore console or the Admin SDK).
// Read it through AuthContext's `platformAdmin` flag rather than reaching into
// userProfile directly.
// ─────────────────────────────────────────────────────────────────────────────

export const BONEFLOW_INTERNAL_COMPANY_ID = 'boneflow-internal';

export function isInternalCompanyId(companyId) {
  return companyId === BONEFLOW_INTERNAL_COMPANY_ID;
}

export function isPlatformAdmin(userProfile) {
  return userProfile?.platformAdmin === true;
}
